import React, { useState } from 'react';
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';
import { message } from 'antd';
import { arrayMoveImmutable } from 'array-move';
import { MenuOutlined } from '@ant-design/icons';
import { surveyApis } from 'apis/operation/surveyApis';
import DefaultButton from 'components/button/DefaultButton';
import SubordinateTable from 'components/table/SubordinateTable';
import QuestionInputModal from './QuestionInputModal';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import TableToolbar from 'components/table/TableToolbar';
import { useTranslation } from 'react-i18next';

// 정렬 아이콘
const DragHandle = sortableHandle(() => (
  <MenuOutlined style={{ cursor: 'pointer', color: '#999' }} />
));
const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
const SurveyDetailTable = ({
  dataSource,
  fetchData,
  surveyRecord,
  disabled,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState({
    register: false,
    update: false,
  });
  const [record, setRecord] = useState();
  const columns = [
    // {
    //   title: '질문',

    //   dataIndex: 'survey_id',
    //   key: '',
    // },
    {
      title: t('survey.table.nestBody.table.questionNumber'),
      render: (t, r, i) => {
        return i + 1;
      },
    },
    {
      title: t('survey.table.nestBody.table.questionName'),
      dataIndex: 'question_text',
      key: '',
    },
    {
      title: t('survey.table.nestBody.table.answerType'),
      dataIndex: 'answer_kind',
      key: '',
      render: (_, r, i) => {
        return r.answer_kind === 0
          ? t('survey.table.nestBody.table.answerTypeSelect.multipleChoice')
          : t('survey.table.nestBody.table.answerTypeSelect.shortForm');
      },
    },
    {
      title: t('survey.table.nestBody.table.action'),
      dataIndex: 'move',
      key: 'move',
      render: (text, record, index) => {
        return (
          <div>
            <CapsuleButton
              name='update'
              onClick={handleVisible(record)}
              disabled={disabled}
            >
              {t('survey.table.nestBody.table.edit')}
            </CapsuleButton>
            <DeletePopConfirm
              title={t('survey.table.nestBody.table.deleteMessage')}
              onConfirm={handleDelete(record)}
              disabled={disabled}
            />
          </div>
        );
      },
    },
    {
      title: t('survey.table.nestBody.table.sort'),
      width: '5rem',
      render: () => <DragHandle />,
    },
  ];
  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    // ***** int로 변환해주었어야 했다!
    const index = dataSource.findIndex(
      (item) => parseInt(item.key) === parseInt(restProps['data-row-key']),
    );
    return <SortableItem index={index} {...restProps} />;
  };
  const DraggableContainer = (props) => {
    return (
      <SortableContainer
        useDragHandle
        disableAutoscroll
        helperClass='row-dragging' // 정렬 아이콘 클릭 된 상태로 움직일 때의 모습 스타일링
        onSortEnd={onSortEnd}
        {...props}
      />
    );
  };

  /// 정렬 드래깅이 끝날 때 => api 호출
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    if (disabled) {
      return false;
    } //권한이 없을 때 return시킨다
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(
        [].concat(dataSource),
        oldIndex,
        newIndex,
      ).filter((el) => !!el);
      let sortData = newData.map((v, i) => {
        v.id = v.question_id;
        return v;
      });
      const res = await surveyApis.questionSorting(
        dataSource[0].survey_id,
        sortData,
      );
      if (!res) {
        return false;
      }

      fetchData();
      // (sortData);
      message.success(t('survey.table.nestBody.table.onSortEndSuccessMessage'));
    }
  };

  const handleDelete = (record) => async () => {
    console.log(surveyRecord.survey_id, record.question_id);
    const res = await surveyApis.questionDelete(
      surveyRecord.survey_id,
      record.question_id,
    );
    if (!res) {
      return false;
    }
    fetchData();
    message.success(t('survey.table.nestBody.table.deleteSuccessMessage'));
  };

  const handleVisible = (r) => (e) => {
    const { name } = e.target;
    setVisible({ ...visible, [name]: true });
    if (r) {
      setRecord(r);
    }
  };
  return (
    <div>
      <TableToolbar>
        <div></div>
        <DefaultButton
          onClick={handleVisible()}
          name='register'
          disabled={disabled}
        >
          {t('survey.table.nestBody.header.addQuestion')}
        </DefaultButton>
      </TableToolbar>
      <SubordinateTable
        columns={columns}
        dataSource={dataSource}
        rowKey={(record) => `${record.key}`}
        components={
          dataSource && {
            body: {
              style: { color: 'blue' },
              wrapper: DraggableContainer,
              row: DraggableBodyRow,
            },
          }
        }
      />
      {visible.register && (
        <QuestionInputModal
          visible={visible.register}
          setVisible={setVisible}
          fetchData={fetchData}
          surveyRecord={surveyRecord}
        />
      )}
      {visible.update && (
        <QuestionInputModal
          visible={visible.update}
          setVisible={setVisible}
          fetchData={fetchData}
          surveyRecord={surveyRecord}
          record={record}
        />
      )}
    </div>
  );
};
export default SurveyDetailTable;
